export var AUTHENTICATION_REPOSITORY = 'AUTHENTICATION_REPOSITORY';